module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAVCAMAAACqsJS4AAAAh1BMVEUAAAAA//8AgP8AgP8AgP8AgP8Ajv8Ai/8AgP8AiP8Ahv8Ahf8AgP8Ae/8Afv8AfP8Aev8Ae/8Ae/8Aev8AfP8Aev8Aev8Ae/8Ae/8Ae/8Ae/8Ae/8Ae/8Ae/8Aev8Ae/8Ae/8Aev8Aev8Aev8Ae/8Aev8Aev8Ae/8Ae/8Ae/8Ae/8Aev8Aev9Eci9zAAAALHRSTlMAAQIEBggJCwwPExccOkFISVFZYmt1f5Odpq62t72+xczT2fDz9Pb3+fv9/m0a/Q0AAAB3SURBVBhXXZDXEsJQCESxl6gxscaWXtTz/9+nYyATL0+cYVh2EbEanA5dL8MzHA1GEWDD8QXee4XpDV47hfkDnqHCIoYmUFgmUPkKXgrFRmGVQb5WkPv3jqm5s99eaXutZr3t8O+eyKzvRWRy7fl0Mjj5nOztXz7Cjg2LWSe7xwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-navigation/lib/views/assets/back-icon.png
// module id = 624
// module chunks = 0